import { template } from "@ember/template-compiler";
import { type TOC } from '@ember/component/template-only';
import type { WithBoundArgs as WBA } from '@glint/template';
import type Patient from 'parog-web/models/patient';
import TreatmentsSection from './treatments-section';
interface Signature {
    Args: {
        patient: Patient;
    };
    Blocks: {
        default: [WBA<typeof TreatmentsSection, 'codes'>];
    };
}
const codes = (patient1: Patient)=>{
    return [
        'nephro-transplant',
        'cardio-heart-failure',
        'pneumo-transplant',
        'hepato-transplant',
        'cardio-transplant',
        'onco-ovarian-cancer',
        'onco-pancreatic-cancer',
        'onco-testicular-cancer',
        'onco-prostate-cancer',
        'onco-lymphoma-cancer',
        'onco-stomach-cancer',
        'onco-myeloma-cancer',
        'nephro-mrc',
        'onco-kidney-cancer',
        'onco-hemato-cancer',
        'onco-lung-cancer',
        'onco-cervix-cancer',
        'onco-breast-cancer',
        'onco-breast-cancer-tnm0',
        'onco-liver-cancer',
        'onco-skin-cancer',
        'onco-colon-cancer',
        'onco-brain-cancer'
    ].includes(patient1.followUpReason) ? [
        'B03X'
    ] : [];
};
const TreatmentsFields: TOC<Signature> = template(`
  {{#let (codes @patient) as |codes|}}
    {{#if codes.length}}
      {{yield (component TreatmentsSection codes=codes)}}
    {{/if}}
  {{/let}}
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default TreatmentsFields;
